<template>
  <div :class="[$style.config, $style.progressBar]">
    <span :class="$style.bar" :style="computedBarStyles" />
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  percentage: number
}>()

const computedBarStyles = computed(() => {
  return {
    '--bar-width': `${props.percentage < 100 ? props.percentage : 100}%`,
  }
})
</script>

<style lang="scss" module>
.config {
  --progress-bar-background: #e3e3e3;
  --progress-bar-fill-color: var(--purple);
}

.progressBar {
  position: relative;
  height: 5px;
  border-radius: 5px;
  background: var(--progress-bar-background);
}

.bar {
  position: absolute;
  top: 0;
  left: 0;
  border-radius: inherit;
  background-color: var(--progress-bar-fill-color);
  height: 100%;
  width: var(--bar-width);
}
</style>
